import React, {useState} from "react";
import {Grid} from "@material-ui/core";
import "./HankaContentWindow.css";
import Gimage from "./Gimage";
import {BoothItem} from "../Data/BoothItems";

interface HankaContentWindow{
    color:string;
    item:BoothItem;
}

const HankaContentWindow:React.FC<HankaContentWindow> = (props)=> {
    const [isHovering,setIsHovering] = useState(false);
    return(
        <Grid item sm={3} xs={12}>
            <div className={"HankaContentWindowBase"}>
                <div className={"HankaContentWindowContainer"} onMouseEnter={()=>setIsHovering(true)} onMouseLeave={()=>setIsHovering(false)} onClick={() => {window.open(props.item.linkURL,"blank")}}>

                    <div className={"HankaContentHoverEffect " + (isHovering ? "Active":"InActive")} style={{backgroundColor:props.color}}/>
                    <div className={"HankaContentHoverEffect " + (isHovering ? "Active":"InActive")} style={{backgroundColor:"#1a1a1a",transitionDelay:"0.05s"}}/>
                    <div className={"HankaContentHoverEffect " + (isHovering ? "Active":"InActive")} style={{backgroundColor:props.color,transitionDelay:"0.1s"}}/>
                    <Grid container className={"HankaContentWindowContent"}>
                        <Grid item xs={4}>
                            <div className={"Padding10"}>
                                <Gimage src={props.item.imageURL}/>
                            </div>
                        </Grid>
                        <Grid item xs={8}>
                            <div className={"SectionSubtitle"}>
                                {props.item.title}
                            </div>
                            <hr className={"HankaContentHR"}/>
                            <div>
                                {props.item.subtitle}
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </Grid>
    );
};

export default HankaContentWindow;